/* Homepage motion (2026 redesign): scroll reveals, a one-time count-up, the best-seller swipe row buttons, the customer photo
   slideshow, the review wall and the proof console. Loaded by every homepage section; runs once. Only the slideshow and the
   review wall keep moving, each with a pause button (WCAG 2.2.2); nothing moves for reduced-motion visitors. */
(function () {
  'use strict';
  if (window.__bhmHome) return;
  window.__bhmHome = true;

  var docEl = document.documentElement;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var design = !!(window.Shopify && window.Shopify.designMode);
  var motion = docEl.classList.contains('bhm-motion') && !reduce.matches && !design && 'IntersectionObserver' in window;
  // Content is hidden for the reveal only from here on, so a script that never loads never hides anything
  if (motion) docEl.classList.add('bhm-ready'); else docEl.classList.remove('bhm-motion');

  function fmt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function countUp(el) {
    if (el.dataset.bhmCounted) return;
    el.dataset.bhmCounted = '1';
    var target = Number(el.getAttribute('data-bhm-count'));
    if (!motion || !(target > 0)) return;
    var start = null, dur = 1100;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(target * eased);
      if (t < 1) window.requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    el.textContent = '0';
    window.requestAnimationFrame(step);
  }

  var io = null;
  // In a row that scrolls sideways, all its cards reveal together, so a card swiped or tabbed into view is never blank
  function reveal(el) {
    var p = el.parentElement;
    var group = p && p.hasAttribute('data-bhm-track') && p.scrollWidth > p.clientWidth + 4 ? p.children : [el];
    Array.prototype.forEach.call(group, function (x) {
      if (!x.hasAttribute('data-reveal') || x.classList.contains('is-in')) return;
      x.classList.add('is-in');
      if (io) io.unobserve(x);
      Array.prototype.forEach.call(x.querySelectorAll('[data-bhm-count]'), countUp);
    });
  }
  if (motion) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) reveal(e.target); });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
  }
  function initReveals(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-reveal]:not(.is-in)'), function (el) {
      if (io) io.observe(el); else reveal(el);
    });
  }

  /* Swipe row: previous and next buttons, shown only when the row actually scrolls */
  function initTracks(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bhm-track]'), function (track) {
      if (track.dataset.bhmTrack === 'ready') return;
      track.dataset.bhmTrack = 'ready';
      var section = track.closest('section') || scope;
      var wrap = section.querySelector('[data-bhm-scroll-btns]');
      var prev = section.querySelector('[data-bhm-prev]');
      var next = section.querySelector('[data-bhm-next]');
      if (!wrap || !prev || !next) return;
      function stepSize() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var scrollable = track.scrollWidth > track.clientWidth + 4;
        wrap.hidden = !scrollable;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
      function go(dir) {
        track.scrollBy({ left: dir * stepSize(), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') go(-1); });
      next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') go(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      // Tabbing through the row: bring the focused card fully into view (scroll-snap would otherwise leave it half hidden)
      track.addEventListener('focusin', function (e) {
        var card = e.target.closest('.bhm-card');
        if (!card || (e.target.matches && !e.target.matches(':focus-visible'))) return;
        var t = track.getBoundingClientRect(), c = card.getBoundingClientRect();
        if (c.left < t.left || c.right > t.right) card.scrollIntoView({ inline: 'start', block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Keyboard (and assistive technology) focus, as opposed to a mouse press or a tap, which also focus a control
  function keyboardFocus(el) { try { return el.matches(':focus-visible'); } catch (err) { return true; } }
  // Runs fn if the visitor switches reduced motion on while the page is open
  function onReduce(fn) {
    var h = function (e) { if (e.matches) fn(); };
    if (reduce.addEventListener) reduce.addEventListener('change', h); else if (reduce.addListener) reduce.addListener(h);
  }

  /* ---------- Customer photo slideshow ---------- */
  // Far photos keep their address in data-src until they are about to be shown
  function loadSlide(s) {
    if (!s) return;
    Array.prototype.forEach.call(s.querySelectorAll('img[data-src]'), function (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); });
  }
  function initShows(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bhm-show]'), function (show) {
      if (show.dataset.bhmShowReady) return;
      var slides = Array.prototype.slice.call(show.querySelectorAll('[data-bhm-slide]'));
      if (slides.length < 2) return;
      show.dataset.bhmShowReady = '1';
      var count = slides.length;
      var interval = Math.max(3000, Number(show.getAttribute('data-interval')) || 6000);
      var wantAuto = show.getAttribute('data-autoplay') === 'true' && motion;
      var prev = show.querySelector('[data-bhm-show-prev]'), next = show.querySelector('[data-bhm-show-next]');
      var toggle = show.querySelector('[data-bhm-show-toggle]'), label = toggle && toggle.querySelector('[data-bhm-toggle-label]');
      var current = show.querySelector('[data-bhm-current]'), status = show.querySelector('[data-bhm-show-status]');
      var progress = show.querySelector('[data-bhm-progress]'), thumbsWrap = show.querySelector('[data-bhm-thumbs]');
      var stage = show.querySelector('.bhm-show__stage');
      var index = 0, timer = null, userPaused = !wantAuto, hovered = false, visible = false;
      var remaining = interval, startedAt = 0; // time left on the current photo, so a pause resumes where it stopped
      show.style.setProperty('--int', interval + 'ms');
      // Thumbnails use the small Loox copy that the blurred backdrop already uses; loading is set before src, or the browser fetches at once
      var thumbs = slides.map(function (s, i) {
        var small = s.querySelector('.bhm-slide__bg') || s.querySelector('.bhm-slide__img');
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bhm-thumb';
        b.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + count);
        var t = document.createElement('img'); t.alt = ''; t.loading = 'lazy'; t.decoding = 'async'; t.src = small.getAttribute('src');
        b.appendChild(t);
        b.addEventListener('click', function () { userPaused = true; syncToggle(); go(i, true); });
        if (thumbsWrap) thumbsWrap.appendChild(b);
        return b;
      });
      // Every photo but the first waits in data-src; go() loads the one shown and its neighbours (still lazy until near the screen)
      slides.forEach(function (s, k) {
        if (k === 0) return;
        Array.prototype.forEach.call(s.querySelectorAll('img[src]'), function (img) { img.setAttribute('data-src', img.getAttribute('src')); img.removeAttribute('src'); });
      });
      show.classList.add('is-ready');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function playing() { return !userPaused && !hovered && visible && !document.hidden; }
      function restartProgress() {
        if (!progress) return;
        progress.classList.remove('is-run'); void progress.offsetWidth; progress.classList.add('is-run');
      }
      function schedule() {
        clearTimeout(timer); timer = null;
        if (startedAt) { remaining -= window.performance.now() - startedAt; startedAt = 0; }
        var on = playing();
        show.classList.toggle('is-playing', on);
        if (on) { startedAt = window.performance.now(); timer = setTimeout(function () { go(index + 1, false); }, Math.max(0, remaining)); }
      }
      function go(i, announce) {
        index = (i + count) % count;
        loadSlide(slides[index]); loadSlide(slides[(index + 1) % count]); loadSlide(slides[(index - 1 + count) % count]);
        slides.forEach(function (s, k) {
          var on = k === index;
          s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); } else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
        });
        thumbs.forEach(function (b, k) { if (k === index) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        var tb = thumbs[index];
        if (tb && thumbsWrap) { var l = tb.offsetLeft - thumbsWrap.clientWidth / 2 + tb.offsetWidth / 2; thumbsWrap.scrollTo({ left: l, behavior: reduce.matches ? 'auto' : 'smooth' }); }
        if (current) current.textContent = pad(index + 1);
        if (announce && status) status.textContent = 'Photo ' + (index + 1) + ' of ' + count;
        // the incoming photo restarts its slow zoom; the outgoing one keeps its zoom while it fades
        var img = slides[index].querySelector('.bhm-slide__img');
        if (img) { img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
        remaining = interval; startedAt = 0;
        restartProgress();
        schedule();
      }
      // The label says what a press does; the icon follows data-state
      function syncToggle() {
        if (toggle) {
          toggle.setAttribute('data-state', userPaused ? 'paused' : 'playing');
          if (label) label.textContent = userPaused ? 'Play slideshow' : 'Pause slideshow';
        }
        schedule();
      }
      if (!motion && toggle) toggle.hidden = true;
      if (prev) prev.addEventListener('click', function () { userPaused = true; syncToggle(); go(index - 1, true); });
      if (next) next.addEventListener('click', function () { userPaused = true; syncToggle(); go(index + 1, true); });
      // An explicit Play wins over the hover pause, so it plays even with the pointer still on the slideshow
      if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; if (!userPaused) hovered = false; syncToggle(); });
      show.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovered = true; schedule(); } });
      show.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovered = false; schedule(); } });
      // Keyboard focus from outside, or on a photo's link or a thumbnail, stops the rotation until the visitor presses Play
      // (WAI-ARIA carousel pattern). After Play, moving between the buttons keeps it playing; a focused link is never made inert.
      show.addEventListener('focusin', function (e) {
        if (userPaused || !keyboardFocus(e.target)) return;
        if (show.contains(e.relatedTarget) && e.target.closest('.bhm-show__controls')) return;
        userPaused = true; syncToggle();
      });
      // Arrow keys change the photo; focus on the old photo's link moves to the new one, so it isn't lost when the old slide goes inert.
      // Arrows with Alt, Ctrl, Shift or Meta are left to the browser (e.g. Alt+Left is Back).
      show.addEventListener('keydown', function (e) {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var fromSlide = slides[index].contains(document.activeElement);
        userPaused = true; syncToggle();
        go(index + (e.key === 'ArrowRight' ? 1 : -1), true);
        if (fromSlide) { var a = slides[index].querySelector('a'); if (a) a.focus(); }
      });
      // Swipe: touch-action pan-y lets the browser keep vertical scrolling and hand sideways moves to us
      var x0 = null;
      if (stage) {
        stage.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') x0 = e.clientX; });
        stage.addEventListener('pointercancel', function () { x0 = null; });
        stage.addEventListener('pointerup', function (e) {
          if (x0 === null) return; var dx = e.clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) { userPaused = true; syncToggle(); go(index + (dx < 0 ? 1 : -1), true); }
        });
      }
      document.addEventListener('visibilitychange', schedule);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[es.length - 1].isIntersecting; schedule(); }, { threshold: 0.35 }).observe(show);
      } else { visible = true; }
      onReduce(function () { userPaused = true; if (toggle) toggle.hidden = true; syncToggle(); });
      syncToggle();
      go(0, false);
    });
  }

  /* ---------- Review wall: move only while on screen; pause button; keyboard focus stops it ---------- */
  function initWalls(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bhm-wall]'), function (wall) {
      if (wall.dataset.bhmWallReady) return;
      wall.dataset.bhmWallReady = '1';
      var toggle = wall.querySelector('[data-bhm-wall-toggle]'), label = toggle && toggle.querySelector('[data-bhm-toggle-label]');
      var rows = Array.prototype.slice.call(wall.querySelectorAll('[data-bhm-marquee]'));
      function sync() {
        var paused = wall.classList.contains('is-paused') || !wall.classList.contains('is-running');
        if (!toggle) return;
        toggle.setAttribute('data-state', paused ? 'paused' : 'playing');
        if (label) label.textContent = paused ? 'Play moving reviews' : 'Pause moving reviews';
      }
      // The hand-scroll layout: no movement, no repeated copy, every card reachable
      function still() { wall.classList.remove('is-running', 'is-paused'); sync(); }
      // Keyboard focus on a review: the first one stops a moving wall (a moving row would push cards off screen), and every one
      // brings its whole card into view (sideways in its row, and below the fixed header), which the browser doesn't do for a
      // card that is partly visible. Also with reduced motion. Mouse presses and taps are left alone, so a click on a product
      // link still lands on it. Coming back to the tab or window fires focusin again on the link that already had focus: that
      // one is left alone, so the page stays where the visitor scrolled it.
      var back = null;
      window.addEventListener('blur', function () { back = document.activeElement; });
      window.addEventListener('focus', function () { setTimeout(function () { back = null; }, 0); });
      wall.addEventListener('focusin', function (e) {
        if (e.target === back || !keyboardFocus(e.target)) return;
        var card = e.target.closest('.bhm-wall__card');
        if (!card || card.closest('[data-bhm-copy]')) return;
        if (wall.classList.contains('is-running')) still();
        var row = card.closest('[data-bhm-marquee]');
        if (!row) return;
        var pad = parseFloat(window.getComputedStyle(docEl).scrollPaddingTop) || 0;
        var rr = row.getBoundingClientRect(), cr = card.getBoundingClientRect();
        if (cr.left < rr.left || cr.right > rr.right || cr.top < pad - 1 || cr.bottom > window.innerHeight + 1) card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      if (!motion) return;
      wall.classList.add('is-live', 'is-running');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var on = es[es.length - 1].isIntersecting;
          wall.querySelectorAll('.bhm-marquee__track').forEach(function (t) { t.style.animationPlayState = on ? '' : 'paused'; });
        }, { threshold: 0 }).observe(wall);
      }
      if (toggle) toggle.addEventListener('click', function () {
        if (!wall.classList.contains('is-running')) { rows.forEach(function (r) { r.scrollLeft = 0; }); wall.classList.add('is-running'); wall.classList.remove('is-paused'); }
        else wall.classList.toggle('is-paused');
        sync();
      });
      onReduce(function () { still(); wall.classList.remove('is-live'); });
      sync();
    });
  }

  /* ---------- Proof console ---------- */
  function initProof(scope) {
    // The scan line travels the full height of the tile grid, which changes with the width
    Array.prototype.forEach.call(scope.querySelectorAll('.bhm-auth__panel'), function (p) {
      if (p.dataset.bhmScan) return;
      p.dataset.bhmScan = '1';
      function set() { p.style.setProperty('--scan-h', p.offsetHeight + 'px'); }
      set();
      if ('ResizeObserver' in window) new ResizeObserver(set).observe(p);
    });
    // A tile link to a section of this page: the theme's own "#" link scroller (theme.js) is kept out, so the browser's
    // fragment navigation runs, which honours the header offset (html scroll-padding-top) and moves the Tab start point there.
    // A link whose section isn't shown (e.g. no customer photos left) is dropped.
    Array.prototype.forEach.call(scope.querySelectorAll('.bhm-hud__links a[href^="#"]'), function (a) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      if (document.getElementById(id)) {
        if (!a.dataset.bhmAnchor) { a.dataset.bhmAnchor = '1'; a.addEventListener('click', function (e) { e.stopPropagation(); }); }
        return;
      }
      var p = a.parentNode;
      p.removeChild(a);
      if (p && !p.querySelector('a') && p.parentNode) p.parentNode.removeChild(p);
    });
  }

  function init(scope) { initReveals(scope); initTracks(scope); initShows(scope); initWalls(scope); initProof(scope); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
